import React, { useState } from 'react'
import LockKeySVG from 'images/forgot-pw.svg'

import { sendResetPasswordEmail } from 'services/user'

import './ForgotPasswordModal.scss'
import { useForm } from 'react-hook-form'
import { ButtonWithLoadingSpinner } from '../../../profile/ButtonWithLoadingSpinner'
import { Captcha } from '../../Captcha'

const ForgotPasswordModal = ({ closeModal }) => {
  const [resetEmailSent, setResetEmailSent] = useState(false)
  const [serverError, setServerError] = useState(false)
  const [loading, setLoading] = useState(false)
  const { register, watch, handleSubmit, setValue } = useForm()

  const onSubmit = async (data, e) => {
    setLoading(true)
    e.preventDefault()
    e.stopPropagation()
    const email = data.email
    const recaptchaToken = data.recaptchaToken

    try {
      const response = await sendResetPasswordEmail({
        email,
        recaptchaToken,
      })

      if (response.status === 200) {
        setResetEmailSent(true)
      } else {
        setServerError('An error has occurreed. BR-238947')
      }
    } catch (e) {
      setServerError(e.message)
    }
    setLoading(false)
  }

  const emailWatch = watch('email')
  const recaptchaTokenWatch = watch('recaptchaToken')
  const disableSubmit = emailWatch?.length <= 0 || !recaptchaTokenWatch

  return (
    <div className={`modal-forgot button-ready-${disableSubmit}`}>
      <button
        className={`modal-close`}
        onClick={closeModal}
        aria-label="Next"
      ></button>
      <img className="header-image" src={LockKeySVG} alt="" />
      {!resetEmailSent && (
        <>
          <h1>Forgot Password</h1>
          <p>
            Enter the email address associated with this account and we’ll send
            you a link to reset your password.
          </p>
          <form onSubmit={handleSubmit(onSubmit)} name="forgot-pw">
            <div className="input-container">
              <input
                {...register('email', { required: true })}
                type="text"
                placeholder="Enter your email"
                name="email"
              />
              <Captcha
                className="recaptcha-container"
                onChange={recaptchaToken => {
                  setValue('recaptchaToken', recaptchaToken)
                }}
              />
            </div>
            <ButtonWithLoadingSpinner
              className={'reset-password-button'}
              type={'submit'}
              color="primary"
              disabled={disableSubmit || loading}
              loading={loading}
              onClick={handleSubmit(onSubmit)}
            >
              Send reset link
            </ButtonWithLoadingSpinner>
          </form>
        </>
      )}
      {serverError && <span className="server-error">{serverError}</span>}
      {resetEmailSent && (
        <>
          <h1>Sent!</h1>
          <p>
            Thanks! We've sent you an email with a link to reset your password.
          </p>
        </>
      )}
    </div>
  )
}

export default ForgotPasswordModal
